import React, { useEffect, useRef, useState } from "react";
import InputField from "../forms/input-field";
import AsyncCreateSelect from "../forms/async-create-select-field";
import { useFormikContext } from "formik";
import { useNavigate } from "react-router-dom";
import {
  customerListAction,
  newWareHouseListAction,
  wareHouseListAction,
} from "../../redux/actions/general-action";
import { useDispatch } from "react-redux";
import excelImg from "../../assets/icons/excel.png";
import DownloadIcon from "../../assets/icons/download-icon";
import LoadingButtonSpinner from "../helper-components/loading-button-spinner";
import { downloadAllTemplates } from "../helper-components/helper-function";
import PersonIcon from "../../assets/icons/person-icon";
import SearchField from "../forms/search-field";
import OutstandingBalanceInfo from "../helper-components/outstanding-bal-information";
import ItemsInputField from "../forms/items-input-field";
import AddButton from "../buttons/button";
import { goodsUserTemplateAction } from "../../redux/actions/purchase-action";
import AddressSidebar from "../common-components/address-bar";
import { MapPin } from "lucide-react";
import { useHotkeys } from "react-hotkeys-hook";
import SelectField from "../forms/select-field";
import AddressSidebarSales from "../common-components/address-bar-sales";
import moment from "moment";

const SalesPurchaseNavbar = ({
  isClone = false,
  pageType,
  pageName = "",
  currentPage = "",
  page = "",
  disabled = false,
  searchRef = {},
  name = "",
  section = "",
  importcsv = false,
  handleFileUpload = () => {},
  loading,
  tempalteArray = [],
  csvButtonText = "Import CSV",
  csvTemLoading = false,
  fetchCreditNoteFn = () => {},
  isCusInvNumRequired = true,
  clickedplus,
  autoDraft,
}) => {
  const dispatch = useDispatch();
  const [localData, setLocalData] = useState([]);
  const [warehouseList, setWarehouseList] = useState([]);

  const [addressPanel, setAddressPanel] = useState(false);
  const [customerId, setCustomerId] = useState(null);

  const [isToggled, setIsToggled] = useState(false);

  const navigate = useNavigate();
  const { errors, values, setFieldValue, setFieldError } = useFormikContext();
  const data = useFormikContext();
  const addressRef = useRef(null);

  const mapListToOptions = (data) => {
    return (
      data?.data?.map((item) => ({
        label: item?.warehouse_name,
        value: item?.warehouse_id, // e.g. 123
      })) || []
    );
  };
  const onListSuccess = (data) => {
    setWarehouseList(mapListToOptions(data));
    console.log("lll", data);
  };
  const onListError = (data) => {};
  useEffect(() => {
    dispatch(newWareHouseListAction(onListSuccess, onListError));
  }, []);
  const loadOptions = (inputValue, field) => {
    return new Promise((resolve) => {
      const onSuccess = (data) => {
        const options = [
          ...data.data.map((item) => ({
            value: item.cmr_id,
            label: item?.cmr_code + "-" + item?.cmr_first_name,
          })),
          {
            value: "new_customer",
            label: (
              <span className="text-primary">
                {section === "sales" ? "+ New Customer" : "+ New Vendor"}
              </span>
            ),
          },
        ];
        setLocalData(data.data);
        resolve(options);
      };

      const onError = (error) => {
        resolve([
          {
            value: "new_customer",
            label: (
              <span className="text-primary">
                {section === "sales" ? "+ New Customer" : "+ New Vendor"}
              </span>
            ),
          },
        ]);
      };

      if (inputValue?.length > 0) {
        dispatch(
          customerListAction(
            {
              field: field,
              value: inputValue,
              isVendor: section === "sales" ? true : true,
            },
            onSuccess,
            onError
          )
        );
      } else {
        resolve([]);
      }
    });
  };
  const total_amount = values.data?.reduce(
    (total, item) => total + parseFloat(item.item_total_amount || 0),
    0
  );
  useHotkeys("l", () => {
    if (addressRef.current && values?.cmr_name) {
      addressRef.current.click();
    }
  });

  const handleToggle = (e) => {
    e.preventDefault();
    if (page !== "view") {
      setFieldValue("is_local_purchase", !values.is_local_purchase);
    } else return;
    // setIsToggled(!isToggled);
  };
  return (
    <div className="flex flex-col">
      {pageName === "purchase invoice" && (
        <div className="items-center mt-4 flex flex-row justify-between border border-[var(--address-close-border-color)] rounded-lg p-[20px]">
          <div className="flex flex-row gap-3 items-center">
            <label className="text-[length:var(--purchase-invoice-toggle-label-fs)] font-[var(--purchase-invoice-toggle-label-fw)]">
              Local Purchase
            </label>
            <button
              type="button"
              onClick={handleToggle}
              className={`
            relative inline-flex h-6 w-10 items-center rounded-full transition-colors duration-300 ease-in-out focus:outline-none
            ${
              values.is_local_purchase
                ? "bg-[var(--primary)]"
                : "bg-[var(--purchase-invoice-toggle-bg)]"
            }
          `}
              aria-pressed={values.is_local_purchase}
              aria-label="Toggle button"
            >
              <span
                className={`
              inline-block h-4 w-4 transform rounded-full bg-white shadow-lg transition-transform duration-300 ease-in-out
              ${values.is_local_purchase ? "translate-x-5" : "translate-x-1"}
            `}
              />
            </button>
          </div>
          {console.log("is_local_purchase", values.is_local_purchase)}
          <div className="w-[400px]">
            {console.log("warehouseList", warehouseList)}
            <SelectField
              containerClass="flex-1 min-full"
              placeholder="Select Warehouse"
              options={warehouseList}
              label="On behalf of:"
              id="on_behalf_of_name"
              name="on_behalf_of_name"
              isSearchable={true}
              errMsgContainerClass="hidden"
              // isRequired={true}
              handleSelected={(selectedOption) => {
                setFieldValue("on_behalf_of_name", selectedOption.label);
                setFieldValue("on_behalf_of_id", selectedOption.value);
              }}
              labelWidth="6rem"
              isDisabled={!values.is_local_purchase || disabled}
            />
          </div>
        </div>
      )}

      <div className="min-h-[8rem] flex items-center w-full pt-[1.2rem]">
        <AddressSidebarSales
          isClone={isClone}
          // pageName={pageName}
          autoDraft={autoDraft}
          clickedplus={clickedplus}
          pageType={pageType}
          open={addressPanel}
          setOpen={setAddressPanel}
          id={
            !isClone && pageType === "sales"
              ? page === "add"
                ? customerId
                : values.cmr_id
              : values.cmr_id
          }
          // id={values.cmr_id}
          name={name}
          page={page}
          disabled={disabled}
        />

        <div className="justify-between bg-[var(--add-billing-head-bg)] border-radius h-[87px] flex items-center px-3 w-full">
          <div className="flex gap-3 items-end">
            <div className="w-[162px]  h-fit">
              <SearchField
                type="text"
                label={`${
                  section === "sales"
                    ? "Customer"
                    : (values.is_local_purchase ? "Local " : "") + "Vendor"
                } Code`}
                disabled={disabled}
                menuPortalTarget={document.body}
                className="z-1 "
                isValidNewOption={true}
                autoFocus={true}
                name={"cmr_code"}
                placeholder={`Enter ${
                  section === "sales" ? "Customer" : "Vendor"
                } Code`}
                onCreateOption={() => {}}
                loadOptions={(e) => loadOptions(e, "cmr_code")}
                onChange={(selectedOption, actionMeta) => {
                  if (actionMeta?.action === "clear") {
                    setFieldValue("cmr_code", "");
                    setFieldValue("cmr_name", "");
                  } else if (
                    selectedOption === "new_customer" ||
                    selectedOption?.value === "new_customer"
                  ) {
                    //navigate("/add-customer");
                    navigate("/admin/add-customer");
                  } else {
                    const customerData = localData?.find(
                      (item) => item?.cmr_id === selectedOption?.value
                    );
                    setFieldValue("cmr_code", {
                      label: customerData?.cmr_code,
                      value: customerData?.cmr_id,
                    });
                    setFieldValue("cmr_id", customerData?.cmr_id);
                    setCustomerId(customerData?.cmr_id);
                    setFieldValue(
                      "cmr_balance",
                      parseFloat(customerData?.cmr_credit_balance)
                    );
                    setFieldValue(
                      "cmr_phone_number",
                      customerData?.cmr_phone_number
                    );
                    setFieldValue("cmr_tcs", customerData?.cmr_tcs);
                    setFieldValue("cmr_tds", customerData?.cmr_tds);
                    setFieldValue("cmr_name", {
                      value: customerData?.cmr_id,
                      label: customerData?.cmr_first_name,
                    });
                    const final_total_amount =
                      Math.round(total_amount).toFixed(2);
                    const round_off_value = (
                      Math.round(total_amount) - total_amount
                    ).toFixed(2);
                    setFieldValue(`${name}_tcs_or_tds_percentage_id`, "");
                    setFieldValue(`${name}_tds_tcs_type`, "");
                    setFieldValue(`${name}_tcs_or_tds_percentage`, 0);
                    setFieldValue(`${name}_tcs_or_tds_amount`, 0);
                    setFieldValue(`${name}_round_off_value`, round_off_value);
                    setFieldValue(`${name}_total_amount`, final_total_amount);
                    if (name === "poit" || name === "gort") {
                      dispatch(
                        goodsUserTemplateAction(
                          customerData?.cmr_id,
                          (data) => {
                            const vendorTemplateData =
                              data?.data?.vendorTemplateData;
                            console.log(data, "fgdfgdfgdfgdfgdfg");
                            setFieldValue("vendorTemplate", [
                              {
                                documentType: `${vendorTemplateData?.cmr_vendor_name} - Template`,
                                expectedHeaders:
                                  vendorTemplateData?.excel_columns,
                              },
                            ]);
                          },
                          () => {}
                        )
                      );
                    }

                    if (searchRef && searchRef.current) {
                      searchRef.current.focus();
                      setFieldError("cmr_name", "");
                    }
                  }
                }}
              />
            </div>
            <div className="w-[220px]  h-fit">
              <SearchField
                type="text"
                label={`${
                  section === "sales"
                    ? "Customer"
                    : (values.is_local_purchase ? "Local " : "") + "Vendor"
                } Name`}
                disabled={disabled}
                menuPortalTarget={document.body}
                className="z-1 "
                isValidNewOption={true}
                autoFocus={true}
                name={"cmr_name"}
                placeholder={`Enter ${
                  section === "sales" ? "Customer" : "Vendor"
                } Name`}
                onCreateOption={() => {}}
                loadOptions={(e) => loadOptions(e, "cmr_first_name")}
                onChange={(selectedOption, actionMeta) => {
                  if (actionMeta?.action === "clear") {
                    setFieldValue("cmr_code", "");
                    setFieldValue("cmr_name", "");
                  } else if (
                    selectedOption === "new_customer" ||
                    selectedOption?.value === "new_customer"
                  ) {
                    // navigate("/add-customer");
                    navigate("/admin/add-customer");
                  } else {
                    const customerData = localData?.find(
                      (item) => item?.cmr_id === selectedOption?.value
                    );
                    setFieldValue("cmr_code", {
                      label: customerData?.cmr_code,
                      value: customerData?.cmr_id,
                    });
                    setFieldValue(
                      "cmr_balance",
                      parseFloat(customerData?.cmr_credit_balance)
                    );
                    setFieldValue(
                      "cmr_phone_number",
                      customerData?.cmr_phone_number
                    );
                    setFieldValue("cmr_id", customerData?.cmr_id);
                    // setFieldValue(
                    //   "cmr_balance",
                    //   parseFloat(customerData?.cmr_open_balance)
                    // );
                    setCustomerId(customerData?.cmr_id);

                    setFieldValue("cmr_name", {
                      value: customerData?.cmr_id,
                      label: customerData?.cmr_first_name,
                    });
                    setFieldValue("cmr_tcs", customerData?.cmr_tcs);
                    setFieldValue("cmr_tds", customerData?.cmr_tds);
                    const final_total_amount =
                      Math.round(total_amount).toFixed(2);
                    const round_off_value = (
                      Math.round(total_amount) - total_amount
                    ).toFixed(2);
                    setFieldValue(`${name}_tcs_or_tds_percentage_id`, "");
                    setFieldValue(`${name}_tds_tcs_type`, "");
                    setFieldValue(`${name}_tcs_or_tds_percentage`, 0);
                    setFieldValue(`${name}_tcs_or_tds_amount`, 0);
                    setFieldValue(`${name}_round_off_value`, round_off_value);
                    setFieldValue(`${name}_total_amount`, final_total_amount);
                    if (name === "poit" || name === "gort") {
                      dispatch(
                        goodsUserTemplateAction(
                          customerData?.cmr_id,
                          (data) => {
                            const vendorTemplateData =
                              data?.data?.vendorTemplateData;
                            console.log(data, "fgdfgdfgdfgdfgdfg");
                            setFieldValue("vendorTemplate", [
                              {
                                documentType: `${vendorTemplateData?.cmr_vendor_name} - Template`,
                                expectedHeaders:
                                  vendorTemplateData?.excel_columns,
                              },
                            ]);
                          },
                          () => {}
                        )
                      );
                    }

                    if (searchRef && searchRef.current) {
                      setTimeout(() => {
                        searchRef.current.focus();
                        setFieldError("cmr_name", "");
                      }, 0);
                    }
                  }
                }}
              />
            </div>
            {isCusInvNumRequired && (
              <div className="w-[170px]">
                <ItemsInputField
                  labelClass="min-h-[1.2rem] text-[var(--search-input-label-color)] text-[length:var(--search-label-font-size)] font-[var(--search-label-font-weight)]"
                  inputClass="min-h-[40px] px-2 border border-[var(--search-input-border)] focus:outline-none focus:border-[var(--search-input-focus)] bg-[var(--search-input-bg)] text-[var(--search-input-color)] text-[length:var(--search-input-font-size)] font-[var(--search-input-font-weight)] border-radius input-field-no-spin-buttons"
                  disabled={page === "view"}
                  name={`customer_invoice_number`}
                  label="Invoice Number"
                  isLabelReq={true}
                  placeholder="Enter Invoice Number"
                />
              </div>
            )}
            {(name === "pot" ||
              name === "gort" ||
              name === "poit" ||
              name === "sodtt" ||
              name === "soit") && (
              <div className="w-[130px]">
                <ItemsInputField
                  min={
                    name !== "pot"
                      ? moment(values[`${name}_delivery_date`]).format(
                          "YYYY-MM-DD"
                        )
                      : moment().format("YYYY-MM-DD")
                  }
                  labelClass="min-h-[1.2rem] text-[var(--search-input-label-color)] text-[length:var(--search-label-font-size)] font-[var(--search-label-font-weight)]"
                  inputClass="min-h-[40px] px-2 border border-[var(--search-input-border)] focus:outline-none focus:border-[var(--search-input-focus)] bg-[var(--search-input-bg)] text-[var(--search-input-color)] text-[length:var(--search-input-font-size)] font-[var(--search-input-font-weight)] border-radius input-field-no-spin-buttons"
                  type="date"
                  {...(name === "pot" && {
                    value: moment().format("YYYY-MM-DD"),
                  })}
                  disabled={name === "pot" ? true : disabled}
                  name={`${name}_document_date`}
                  label={name === "pot" ? "Requested Date" : "Due Date"}
                  isLabelReq={true}

                  // placeholder="UOM"
                />
              </div>
            )}
            <div className="w-[130px]">
              <ItemsInputField
                min={moment(values[`${name}_document_date`]).format(
                  "YYYY-MM-DD"
                )}
                labelClass="min-h-[1.2rem] text-[var(--search-input-label-color)] text-[length:var(--search-label-font-size)] font-[var(--search-label-font-weight)]"
                inputClass="min-h-[40px] px-2 border border-[var(--search-input-border)] focus:outline-none focus:border-[var(--search-input-focus)] bg-[var(--search-input-bg)] text-[var(--search-input-color)] text-[length:var(--search-input-font-size)] font-[var(--search-input-font-weight)] border-radius input-field-no-spin-buttons"
                type="date"
                disabled={disabled}
                name={`${name}_delivery_date`}
                label={
                  name === "pot"
                    ? "Delivery Date"
                    : section === "sales"
                    ? "Delivery Date"
                    : "Received Date"
                }
                isLabelReq={true}
                // placeholder="UOM"
              />
            </div>
          </div>
          {/* <div className="w-full flex justify-end">
          <AddButton
            // ref={pastRef}
            icon={<MapPin size={13} />}
            text={
              <>
                Address Details <span className="opacity-50"></span>
              </>
            }
            className={`flex items-center px-[12px] h-[44px] whitespace-nowrap rounded-[8px] gap-[8px] 
                      bg-[var(--general-button-bg)] cursor-pointer 
                      border border-[var(--general-button-border)] 
                      hover:bg-[var(--general-button-bg)]
                      
                      ${
                        !disabled && values?.cmr_name
                          ? "text-[var(--general-button-fg)]"
                          : "text-[var(--general-button-disabled-fg)] opacity-60 pointer-events-none"
                      }`}
            onclkFn={() => {
              setAddressPanel(!addressPanel);
            }}
          />
        </div> */}

          <div className="flex items-center gap-5">
            <AddButton
              ref={addressRef}
              icon={<MapPin size={13} />}
              text={
                <>
                  Address Details <span className="opacity-50">(L)</span>
                </>
              }
              className={`flex items-center px-[12px] h-[44px] whitespace-nowrap rounded-[8px] gap-[8px] 
                      bg-[var(--general-button-bg)] cursor-pointer 
                      border border-[var(--general-button-border)] 
                      hover:bg-[var(--general-button-bg)]
                      
                      ${
                        values?.cmr_name
                          ? "text-[var(--general-button-fg)]"
                          : "text-[var(--general-button-disabled-fg)] opacity-60 pointer-events-none"
                      }`}
              onclkFn={() => {
                setAddressPanel(!addressPanel);
              }}
            />
            {values?.cmr_name?.label &&
              (name === "gort" ||
                name === "poit" ||
                name === "sodtt" ||
                name === "soit") && (
                <OutstandingBalanceInfo
                  conClasss="conClasss flex items-center justify-between gap-7 bg-[var(--out-standing-bg)] px-3 rounded-lg border border-[var(--out-standing-border)] shadow-sm h-[45px] cursor-pointer"
                  onClick={fetchCreditNoteFn}
                  badgeText={
                    <span className="flex items-center gap-2">CR/DB</span>
                  }
                />
              )}

            {importcsv && !disabled && (
              <>
                {name === "pot" && (
                  <input
                    type="file"
                    accept=".csv"
                    onChange={(e) => {
                      // e.target.value = ""; // Reset input value
                      handleFileUpload(e, "vendor");
                    }}
                    className="hidden"
                    id="csv-upload"
                  />
                )}
                {name === "pot" ? (
                  <label htmlFor="csv-upload">
                    <div
                      className="flex items-center px-[12px] h-[44px] whitespace-nowrap rounded-[8px] gap-[8px] 
            bg-[var(--import-button-bg)] cursor-pointer 
            border border-[var(--import-button-border)] 
            hover:bg-[var(--import-button-bg)] 
            text-[var(--import-button-fg)]"
                    >
                      <img
                        width={20}
                        height={30}
                        src={excelImg}
                        alt="excel-icon"
                      />
                      {loading || csvTemLoading ? (
                        <LoadingButtonSpinner className="  h-6 w-6 border-t-2 border-027A48" />
                      ) : (
                        <span>{csvButtonText}</span>
                      )}
                    </div>
                  </label>
                ) : (
                  <AddButton
                    onclkFn={handleFileUpload}
                    icon={
                      <img
                        width={20}
                        height={30}
                        src={excelImg}
                        alt="excel-icon"
                      />
                    }
                    text={
                      <>
                        {loading || csvTemLoading ? (
                          <LoadingButtonSpinner className="  h-6 w-6 border-t-2 border-027A48" />
                        ) : (
                          <span>
                            {" "}
                            {csvButtonText}
                            <span className="opacity-50">(I)</span>
                          </span>
                        )}
                      </>
                    }
                    className={`flex items-center px-[12px] h-[44px] whitespace-nowrap rounded-[8px] gap-[8px] 
            bg-[var(--import-button-bg)] cursor-pointer 
            border border-[var(--import-button-border)] 
            hover:bg-[var(--import-button-bg)] 
            text-[var(--import-button-fg)]`}
                  />
                )}

                {name === "pot" && (
                  <button
                    type="button"
                    onClick={() => {
                      downloadAllTemplates(tempalteArray);
                    }}
                    className="border border-[var(--import-button-border)] rounded-[8px] px-[12px] h-[44px]"
                  >
                    <DownloadIcon fill="var(--success-color)" />
                  </button>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
    // <>
    //   <div class="w-full md:w-full lg:w-2/3 xl:w-[50%] 2xl:w-[48%]  ">
    //     <div className="flex items-center gap-2 w-full  px-2 py-2">
    //       <div className="w-[50%]">
    //         <AsyncCreateSelect
    //           className={`z-30 ${
    //             errors?.cmr_code && !values?.cmr_code
    //               ? "selectField_border__error"
    //               : "selectField_border"
    //           }`}
    //           errorClass="hidden"
    //           disabled={disabled}
    //           marginRight=""
    //           minWidth="8rem"
    //           cusType={section === "sales" ? "Customer" : "Vendor"}
    //           labelClass="whitespace-nowrap flex text-sm fw_600  gap-2 "
    //           type="text"
    //           label={`${section === "sales" ? "Customer" : "Vendor"} Code`}
    //           name={"cmr_code"}
    //           placeholder={`${
    //             section === "sales" ? "Customer" : "Vendor"
    //           } Code`}
    //           onCreateOption={() => {}}
    //           loadOptions={(e) => loadOptions(e, "cmr_code")}
    //           onChange={(selectedOption, actionMeta) => {
    //             if (actionMeta?.action === "clear") {
    //               setFieldValue("cmr_code", "");
    //               setFieldValue("cmr_name", "");
    //             } else if (
    //               selectedOption === "new_customer" ||
    //               selectedOption?.value === "new_customer"
    //             ) {
    //               navigate("/add-customer");
    //             } else {
    //               const customerData = localData?.find(
    //                 (item) => item?.cmr_id === selectedOption?.value
    //               );
    //               console.log(customerData, "dfsfsfsdfsdfsdfsdf");
    //               setFieldValue("cmr_code", {
    //                 label: customerData?.cmr_code,
    //                 value: customerData?.cmr_id,
    //               });
    //               setFieldValue("cmr_id", customerData?.cmr_id);
    //               setFieldValue(
    //                 "cmr_phone_number",
    //                 customerData?.cmr_phone_number
    //               );
    //               setFieldValue("cmr_tcs", customerData?.cmr_tcs);
    //               setFieldValue("cmr_tds", customerData?.cmr_tds);
    //               setFieldValue("cmr_name", {
    //                 value: customerData?.cmr_id,
    //                 label: customerData?.cmr_first_name,
    //               });

    //               if (searchRef && searchRef.current) {
    //                 searchRef.current.focus();
    //                 setFieldError("cmr_name", "");
    //               }
    //             }
    //           }}
    //         />
    //       </div>
    //       {/* <InputField
    //         labelClass="whitespace-nowrap flex text-sm fw_600 text-secondary"
    //         errMsgContainerClass="hidden"
    //         isDisabled={disabled}
    //         containerClass="w-[40%]"
    //         isRequired={false}
    //         type="date"
    //         name={`${name}_order_date`}
    //         placeholder=""
    //         label="Date"
    //         labelWidth="2.5rem"
    //       /> */}
    //       <InputField
    //         labelClass="whitespace-nowrap flex text-sm fw_600 text-secondary "
    //         errMsgContainerClass="hidden"
    //         isDisabled={disabled}
    //         containerClass="w-[50%] pl-1"
    //         isRequired={false}
    //         type="text"
    //         name={`customer_invoice_number`}
    //         placeholder="Enter Inv Number"
    //         label="Invoice Number"
    //         labelWidth="7.5rem"
    //       />
    //     </div>
    //     <div className="w-full px-2 py-2">
    //       <AsyncCreateSelect
    //         menuPortalTarget={document.body}
    //         className={`z-20 ${
    //           errors?.cmr_name && !values?.cmr_name
    //             ? "selectField_border__error"
    //             : "selectField_border"
    //         }`}
    //         errorClass="hidden"
    //         disabled={disabled}
    //         minWidth="8rem"
    //         marginRight=""
    //         cusType={section === "sales" ? "Customer" : "Vendor"}
    //         labelClass="whitespace-nowrap flex text-sm fw_600   gap-2"
    //         type="text"
    //         label={`${section === "sales" ? "Customer" : "Vendor"} Name`}
    //         autoFocus={true}
    //         name={"cmr_name"}
    //         placeholder={`${section === "sales" ? "Customer" : "Vendor"} Name`}
    //         onCreateOption={() => {}}
    //         loadOptions={(e) => loadOptions(e, "cmr_first_name")}
    //         onChange={(selectedOption, actionMeta) => {
    //           if (actionMeta?.action === "clear") {
    //             setFieldValue("cmr_code", "");
    //             setFieldValue("cmr_name", "");
    //           } else if (
    //             selectedOption === "new_customer" ||
    //             selectedOption?.value === "new_customer"
    //           ) {
    //             navigate("/add-customer");
    //           } else {
    //             const customerData = localData?.find(
    //               (item) => item?.cmr_id === selectedOption?.value
    //             );
    //             setFieldValue("cmr_code", {
    //               label: customerData?.cmr_code,
    //               value: customerData?.cmr_id,
    //             });
    //             setFieldValue(
    //               "cmr_phone_number",
    //               customerData?.cmr_phone_number
    //             );
    //             setFieldValue("cmr_id", customerData?.cmr_id);
    //             setFieldValue("cmr_name", {
    //               value: customerData?.cmr_id,
    //               label: customerData?.cmr_first_name,
    //             });
    //             setFieldValue("cmr_tcs", customerData?.cmr_tcs);
    //             setFieldValue("cmr_tds", customerData?.cmr_tds);

    //             setFieldValue("gort_tcs_or_tds_percentage_id", "");
    //             setFieldValue("gort_tcs_or_tds_percentage", 0);
    //             setFieldValue("gort_tds_tcs_type", "");
    //             if (searchRef && searchRef.current) {
    //               setTimeout(() => {
    //                 searchRef.current.focus();
    //                 setFieldError("cmr_name", "");
    //               }, 0);
    //             }
    //           }
    //         }}
    //       />
    //     </div>
    //   </div>
    //   <div class="w-full md:w-full lg:w-2/3 xl:w-[50%] 2xl:w-[50%] flex items-start">
    //     <div className="w-full">
    //       <div className="px-2 py-2">
    //         <InputField
    //           labelClass="whitespace-nowrap flex text-sm fw_600 text-secondary"
    //           containerClass=""
    //           isDisabled={disabled}
    //           errMsgContainerClass="hidden"
    //           type="date"
    //           name={`${name}_document_date`}
    //           label="Document Date "
    //           labelWidth="9rem"
    //           isRequired={true}
    //         />
    //       </div>
    //       <div className="px-2 py-2">
    //         <InputField
    //           labelClass="whitespace-nowrap flex text-sm fw_600 text-secondary"
    //           containerClass=""
    //           isDisabled={disabled}
    //           errMsgContainerClass="hidden"
    //           type="date"
    //           name={`${name}_delivery_date`}
    //           label="Delivery Date"
    //           labelWidth="9rem"
    //           isRequired={true}
    //         />
    //       </div>
    //     </div>

    //     {importcsv && !disabled && (
    //       <div className="px-2 py-2 flex flex-col  gap-3">
    //         {(name === "pot" || name === "gort") && (
    //           <div className="flex items-center gap-3">
    //             <div>
    //               <input
    //                 type="file"
    //                 accept=".csv"
    //                 onChange={(e) => {
    //                   // e.target.value = ""; // Reset input value
    //                   handleFileUpload(e, "vendor");
    //                 }}
    //                 className="hidden"
    //                 id="csv-upload"
    //               />
    //               <label htmlFor="csv-upload">
    //                 <div className="border-027A48 border-2 rounded-md flex items-center gap-2 text-nowrap px-5 py-2 fw_700">
    //                   <img
    //                     width={20}
    //                     height={30}
    //                     src={excelImg}
    //                     alt="excel-icon"
    //                   />
    //                   {loading || csvTemLoading ? (
    //                     <LoadingButtonSpinner className="  h-6 w-6 border-t-2 border-027A48" />
    //                   ) : (
    //                     <span>{csvButtonText}</span>
    //                   )}
    //                 </div>
    //               </label>
    //             </div>

    //             {name === "pot" && (
    //               <button
    //                 type="button"
    //                 onClick={() => {
    //                   downloadAllTemplates(tempalteArray);
    //                 }}
    //                 className="border-027A48 border-2 rounded-md px-2 py-2"
    //               >
    //                 <DownloadIcon fill="var(--success-color)" />
    //               </button>
    //             )}
    //           </div>
    //         )}
    //         {name === "gort" && (
    //           <div className=" py-2 flex items-center gap-3">
    //             <button
    //               type="button"
    //               onClick={handleFileUpload}
    //               className="border-027A48 border-2 rounded-md flex items-center gap-2 text-nowrap px-5 py-2 fw_700 w-[9.5rem]"
    //             >
    //               <img width={20} height={30} src={excelImg} alt="excel-icon" />
    //               {loading ? (
    //                 <LoadingButtonSpinner className="  h-6 w-6 border-t-2 border-027A48" />
    //               ) : (
    //                 "Import CSV"
    //               )}
    //             </button>
    //             <button
    //               type="button"
    //               onClick={() => {
    //                 downloadAllTemplates(tempalteArray);
    //               }}
    //               className="border-027A48 border-2 rounded-md px-2 py-2"
    //             >
    //               <DownloadIcon fill="var(--success-color)" />
    //             </button>
    //           </div>
    //         )}
    //       </div>
    //     )}
    //   </div>
    // </>
  );
};

export default SalesPurchaseNavbar;

function ToggleButton({ label = "Toggle", defaultChecked = false, onChange }) {
  const [checked, setChecked] = useState(defaultChecked);

  const [isToggled, setIsToggled] = useState(false);

  const handleToggle = () => {
    setIsToggled(!isToggled);
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="text-center">
        {/* Toggle Button */}
        <button
          onClick={handleToggle}
          className={`
            relative inline-flex h-8 w-14 items-center rounded-full transition-colors duration-300 ease-in-out focus:outline-none
            ${
              isToggled
                ? "bg-[var(--primary)]"
                : "bg-[var(--purchase-invoice-toggle-bg)]"
            }
          `}
          aria-pressed={isToggled}
          aria-label="Toggle button"
        >
          <span
            className={`
              inline-block h-6 w-6 transform rounded-full bg-white shadow-lg transition-transform duration-300 ease-in-out
              ${isToggled ? "translate-x-7" : "translate-x-1"}
            `}
          />
        </button>
      </div>
    </div>
  );
}
